module.exports = __webpack_public_path__ + "static/img/2.cd4cf06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newSeven/2.png
// module id = 3j47
// module chunks = 0